import type { StyleProp } from '@vtex/admin-ui'
import { ModalHeader, Text, csx } from '@vtex/admin-ui'
import type { ReactNode } from 'react'
import React from 'react'

import { Avatar } from '../Avatar'
import { ElapsedTimer } from '../ElapsedTimer'

const headerStyles: StyleProp = {
  display: 'block',
  padding: '$space-0',
  height: 'auto',
  border: 'none',
  // ModalHeader creates an inside div we have no control
  '> div': {
    display: 'flex',
  },
}

const headerSellerAreaStyles: StyleProp = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  backgroundColor: '#F4F6FB',
  paddingX: '$space-5',
  paddingY: '$space-4',
}

const childrenWrapperStyles: StyleProp = {
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  borderBottom: '#E0E2E7',
  minHeight: '72px',
  padding: '$space-5',
}

export type SalesAssociateMovementsTrackingModalHeaderProps = {
  avatarUrl?: string
  sellerName: string | null
  additionalName?: string | ReactNode
  timerDate?: Date
  children: ReactNode
}

export const SalesAssociateMovementsTrackingModalHeader = ({
  avatarUrl,
  sellerName,
  additionalName,
  timerDate,
  children,
}: SalesAssociateMovementsTrackingModalHeaderProps) => (
  <ModalHeader className={csx({ ...headerStyles })}>
    <div className={csx({ ...headerSellerAreaStyles })}>
      <div className={csx({ display: 'flex', alignItems: 'center' })}>
        <Avatar src={avatarUrl} size={2.25} />
        <div
          className={csx({
            flexDirection: 'column',
            display: 'flex',
            marginLeft: '$space-2',
          })}
        >
          <Text variant="title2">{sellerName}</Text>
          {additionalName}
        </div>
      </div>
      {timerDate && <ElapsedTimer startTime={timerDate} />}
    </div>
    <div className={csx({ ...childrenWrapperStyles })}>{children}</div>
  </ModalHeader>
)
